import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { cacheAdapterEnhancer, Cache } from 'axios-extensions';
import firebase from "firebase/app";

const cache = new Cache({ maxAge: 2 * 1000 });

const axiosConfig = {
  withCredentials: false,
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {},
  adapter: cacheAdapterEnhancer(axios.defaults.adapter, { defaultCache: cache })
};

// Function that will be called to refresh authorization
const refreshAuthLogic = failedRequest => getRefreshedToken().then(idToken => {
  axiosInstance.defaults.headers.common.Authorization = "Bearer " + idToken;
  failedRequest.response.config.headers['Authentication'] = 'Bearer ' + idToken;
  return Promise.resolve();
});

let axiosInstance = axios.create(axiosConfig);
axiosInstance = createAuthRefreshInterceptor(axiosInstance, refreshAuthLogic, { statusCodes: [401] });

let getRefreshedToken = async () => {
  let idToken = await firebase.auth().currentUser.getIdToken(true);
  return Promise.resolve(idToken);
}

let getApi = async () => {
  let idToken = await firebase.auth().currentUser.getIdToken();
  if (idToken) {
    axiosInstance.defaults.headers.common.Authorization = "Bearer " + idToken;
  } else {
    axiosInstance.defaults.headers.common.Authorization = "";
  }
  return axiosInstance;
}

export { getApi, axiosInstance, cache };